<section class="flex flex-col items-center gap-12">
  <app-section-header
    icon="@tui.shield"
    subtitle="Security"
    title="Enterprise-grade security you can trust"
    description="Industry-leading security and compliance features that meet the highest enterprise standards"
  />
  <div class="grid w-full grid-cols-1 gap-8 md:grid-cols-3">
    <div
      class="flex flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.key" class="mr-2" />
        <h3 class="text-xl font-bold">Data Encryption</h3>
      </div>
      <p class="text-pretty text-lg">
        End-to-end encryption for data at rest and in transit, protecting all
        deployments and sensitive information
      </p>
    </div>

    <div
      class="flex flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.lock" class="mr-2" />
        <h3 class="text-xl font-bold">Zero-Trust Security</h3>
      </div>
      <p class="text-pretty text-lg">
        Every Live Update is signed and verified, ensuring integrity and
        authenticity of your deployments
      </p>
    </div>

    <div
      class="flex flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.shield" class="mr-2" />
        <h3 class="text-xl font-bold">Multi-Factor Authentication</h3>
      </div>
      <p class="text-pretty text-lg">
        Mandatory MFA and integration with enterprise identity providers for
        secure access control
      </p>
    </div>
  </div>
</section>
